export const CommonAreaEnum = {
  lookupTypeId: 1228,
};
